import React from 'react';
import * as cls from './transform-customers-experience.module.css';

import { IMG_PATH } from '../../../constants';
import { Section } from '../../../ui/components/section';
import { Typography } from '../../../ui/components/typography';

const items = [
  {
    title: 'Clarity on Energy Use:',
    text: 'see what drives bills, broken down by appliance and compared to peers.',
  },
  {
    title: 'Actionable Insights:',
    text: 'alerts for standby waste, peak EV charging, and saving sessions.',
  },
  {
    title: 'Greener Homes:',
    text: (
      <>
        nudges for sustainable behaviour, targeted upgrade recommendations, and
        - where supported - <b>rewards for sustainable actions</b>.
      </>
    ),
  },
  {
    title: 'No Extra Hardware Required:',
    text: 'immediate smart-bill insights, with optional sensors for premium detail.',
  },
];

export const TransformCustomersExperience = () => {
  return (
    <Section backgroundContrast className={cls.section}>
      <Typography tag="h2">Transform Your Customers’ Experience</Typography>

      <div className={cls.item__wrapper}>
        <ul className={cls.list}>
          {items.map((item, index) => (
            <li key={index}>
              <Typography>{item.title}</Typography>
              <Typography>{item.text}</Typography>
            </li>
          ))}
        </ul>
        <img
          alt="Voltaware helps homes move from inefficient to greener, net-zero living"
          src={`${IMG_PATH}/utilities/Voltaware-transforms-customer-experience.png`}
        />
      </div>
    </Section>
  );
};
